/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';
import {
    START_GUIDE_PAGE_SCROLL,
    STOP_GUIDE_PAGE_SCROLL,
    START_TURBO_SCROLL,
    STOP_TURBO_SCROLL,
} from './turboscroll.types';

export const startTurboScrollAction = (isUpward: boolean = false): AnyAction => ({
    type: START_TURBO_SCROLL,
    payload: {
        isUpward,
        isTurboScrollActive: true,
    },
});

export const stopTurboScrollAction = (): AnyAction => ({
    type: STOP_TURBO_SCROLL,
    payload: {
        isUpward: false,
        isTurboScrollActive: false,
    },
});

export const startGuidePageScrollAction = (isGuidePageUpward: boolean = false): AnyAction => ({
    type: START_GUIDE_PAGE_SCROLL,
    payload: {
        isGuidePageUpward,
        isGuidePageScrollActive: true,
    },
});

export const stopGuidePageScrollAction = (): AnyAction => ({
    type: STOP_GUIDE_PAGE_SCROLL,
    payload: {
        isGuidePageUpward: false,
        isGuidePageScrollActive: false,
    },
});
